import moment from 'moment';
import { CMIC_FIELD_REST__NAMES, CMIC_TREE_NODE_TYPES, ICON_NAMES, USER_ROLE_TYPE } from '../shared/Constants';
import { fetchAttachments, fetchDocRevisions } from './grid/helper/StatusFetch';
import { fetchUserRole } from './fetchData';

export const handleFetchedData = async (type, data, userInfo) => {
	let items = [];

	switch (type) {
		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT:
			items = (data.items || []).map((nodeData, index) => ({
				id: `${nodeData?.ImgdtVUuid}-${index}`,
				name: nodeData.ImgdtDocumentTypeDesc,
				nodeId: nodeData.ImgdtVUuid,
				ecmParentNodeType: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE,
				count: nodeData?.NumDocuments || 0,
				Icon: ICON_NAMES.FOLDER,
				index,
				...nodeData,
			}));

			return {
				...data,
				items,
			};

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
			items = data.items.map((nodeData, index) => {
				const createdDate = moment(nodeData?.ImgdIuCreateDate).format('MMM-DD-YYYY');
				return {
					...nodeData,
					id: nodeData.ImgdVUuid,
					nodeId: nodeData.ImgdVUuid,
					name: nodeData.ImgdDocumentName,
					createdOn: createdDate,
					// ecmParentNodeType: nodeData?.ImgdDocumentRevisionNumber ? CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION : null, // If there's no further navigation then we'll set this as null
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION,
					count: nodeData.ImgdDocumentRevisionNumber,
					Icon: ICON_NAMES.FILE,
					index,
				};
			});

			return {
				items,
				hasMore: data.hasMore,
				totalResults: data.totalResults,
			};

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
			items = data.items.map((nodeData, index) => {
				const createdDate = moment(nodeData?.ImgrIuCreateDate).format('MMM-DD-YYYY');
				return {
					...nodeData,
					id: nodeData.ImgdtVUuid + index,
					nodeId: nodeData.ImgdtVUuid,
					name: nodeData.ImgrRevisionName,
					createdOn: createdDate,
					Icon: ICON_NAMES.FILE,
					ecmParentNodeType: null, // As there's no further navigation then we'll set this as null
					index,
					Icon: ICON_NAMES.FILE_REVERSE,
				};
			});

			return {
				items,
				hasMore: data.hasMore,
				totalResults: data.totalResults,
			};

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
			return data.map((nodeData, index) => ({
				nodeId: nodeData.children[2].value,
				name: decodeURIComponent(`${nodeData.children[2].value}`),
				ecmParentNodeType: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION,
				data: nodeData,
				index,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECTS_PARENT:
			items = data.items.map(nodeData => {
				return {
					nodeId: nodeData.PmpProjOraseq,
					name: `${nodeData.PmpProjName} (${nodeData?.PmpProjCode || '-'})`,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT,
					...nodeData,
				};
			});

			return {
				items,
				hasMore: data.hasMore,
				totalResults: items.length,
			};

		case CMIC_TREE_NODE_TYPES.PROJECT:
			items = (data || []).reduce((arr, item) => {
				if (
					item.ECMPF_CODE === 'COMM' ||
					item.ECMPF_CODE === 'DOC' ||
					item.ECMPF_CODE === 'PMCHGM' ||
					item.ECMPF_CODE === 'SCMAST' ||
					item.ECMPF_CODE === 'PMSCCO'
				) {
				} else {
					arr.push(item);
				}
				return arr;
			}, []);
			items = (items || []).map(nodeData => ({
				nodeId: nodeData.ECMPF_PROJ_ORASEQ,
				name: nodeData.ECMPF_DESC,
				count: nodeData.ECMPF_COUNT,
				ecmParentNodeType: nodeData.ECMPF_CODE,
				data: nodeData,
			}));

			return {
				items,
				totalResults: items.length,
				hasMore: false,
			};

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
			return data.map(nodeData => {
				const _date = moment(nodeData.children[15].value).format('MMM-DD-YYYY');
				return {
					nodeId: nodeData.children[2].value,
					name: `(${nodeData.children[9].value}) ${nodeData.children[8].value} (${nodeData.children[5].value})`,
					count: nodeData.children[5].value,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION,
					data: nodeData,
					commNo: nodeData.children[9].value,
					receivedDate: _date,
					//ReceivedStatus: nodeData.children[11].value,
					submitStatus: nodeData.children[11].value,
					from: nodeData.children[3].value,
					// To: nodeData.children[].value,
					subject: nodeData.children[8].value,
					message: nodeData.children[14].value,
				};
			});

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
			await data.items.map(async (nodeData, index) => {
				items.push(
					new Promise(async (resolve, reject) => {
						// const result = await fetchAttachments(nodeData.VUuid, CMIC_FIELD_REST__NAMES.issues, userInfo);
						const dateCreated = moment(nodeData.DmiIuCreateDate).format('MMM-DD-YYYY');

						// IMPLEMENTATION - ISSUE count is missing => nodeData?.children[3]?.value
						resolve({
							...nodeData,
							nodeId: nodeData.DmiIssueOraseq,
							id: `${nodeData?.DmiIssueOraseq}-${index}`,
							name: nodeData.DmiIssueId,
							// name: `${nodeData.DmiTitle}(${ result.count || 0 })`,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_ISSUE,
							DmiIuCreateDate: dateCreated,
							// count: result.count || 0,
							Icon: ICON_NAMES.FOLDER,
							index,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => {
					console.log('PROMISE ISSue Error:', err);
				});

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
			await data.items.map(async (nodeData, index) => {
				items.push(
					new Promise(async (resolve, reject) => {
						// const result = await fetchAttachments(nodeData.VUuid, CMIC_FIELD_REST__NAMES.rfisv12, userInfo);

						const dateCreated = nodeData.PmscrfiCreateDate
							? moment(nodeData.PmscrfiCreateDate).format('MMM-DD-YYYY')
							: '-';
						const dateRequired = nodeData.PmscrfiRequiredDate
							? moment(nodeData.PmscrfiRequiredDate).format('MMM-DD-YYYY')
							: '-';
						const dateAnswered = nodeData.PmscrfiAnsweredDate
							? moment(nodeData.PmscrfiAnsweredDate).format('MMM-DD-YYYY')
							: '-';

						resolve({
							...nodeData,
							nodeId: nodeData?.PmscrfiRfiOraseq || '-',
							id: `${nodeData?.PmscrfiRfiOraseq}-${index}`,
							index,
							// name: `(${nodeData.PmscrfiRfiId}) ${nodeData.PmscrfiSubject} (${ result.count || 0 })`,
							name: nodeData.PmscrfiRfiId,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_RFI,
							PmscrfiCreateDate: dateCreated,
							PmscrfiRequiredDate: dateRequired,
							PmscrfiAnsweredDate: dateAnswered,
							// count: result.count || 0,
							Icon: ICON_NAMES.FOLDER,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => console.log('PROMISE RFI Error:', err));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
			await data.items.map(async (nodeData, index) => {
				items.push(
					new Promise(async (resolve, reject) => {
						// const result = await fetchAttachments(nodeData.PmsmVUuid, CMIC_FIELD_REST__NAMES.submittals, userInfo);

						const dateDue = nodeData.PmsmCurrEndDateStage6
							? moment(nodeData.PmsmCurrEndDateStage6).format('MMM-DD-YYYY')
							: '-';
						const createdDate = nodeData.PmsmIuCreateDate
							? moment(nodeData.PmsmIuCreateDate).format('MMM-DD-YYYY')
							: '-';

						// IMPLEMENTATION - Submittals count is missing => nodeData?.children[7]?.value
						resolve({
							...nodeData,
							nodeId: nodeData?.PmscrfiRfiOraseq || '-',
							id: `${nodeData?.PmscrfiRfiOraseq}-${index}`,
							name: nodeData.PmsmSbmtId,
							// name: `(${nodeData.PmsmSbmtId}) ${nodeData.PmsmSbmtName} (${ result.count || 0 })`,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS,
							PmsmCurrEndDateStage6: dateDue,
							// count: result.count || 0,
							Icon: ICON_NAMES.FOLDER,
							PmsmIuCreateDate: createdDate,
							index,
							VUuid: nodeData.PmsmVUuid,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => console.log('PROMISE Submittals Error:', err));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
			await data.items.map(async (nodeData, index) => {
				items.push(
					new Promise(async (resolve, reject) => {
						// const result = await fetchAttachments(nodeData.PmjVUuid, CMIC_FIELD_REST__NAMES.journals, userInfo);
						const date = moment(nodeData.PmjDate).format('MMM-DD-YYYY');

						// IMPLEMENTATION - ISSUE count is missing => nodeData?.children[3]?.value
						resolve({
							...nodeData,
							nodeId: nodeData.PmjJournalOraseq,
							name: nodeData?.PmjJournalId || '-',
							// name: `${nodeData?.PmjJournalId}(${ result.count || 0 })` || "-",
							id: `${nodeData?.PmjJournalOraseq}-${index}`,
							// count: result.count || 0,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL || '-',
							PmjDate: date,
							Icon: ICON_NAMES.FOLDER,
							index,
							VUuid: nodeData.PmjVUuid,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => console.log('PROMISE DJ Error:', err));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_PCI:
			await data.items.map(async (nodeData, index) => {
				const refDate = nodeData.CmmRefDate ? moment(nodeData.CmmRefDate).format('MMM-DD-YYYY') : '-';
				items.push(
					new Promise(async (resolve, reject) => {
						resolve({
							...nodeData,
							nodeId: nodeData.CmmOraseq,
							name: nodeData?.CmmCode || '-',
							id: `${nodeData?.CmmOraseq}-${index}`,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_PCI || '-',
							pciRefDate: refDate,
							index,
							VUuid: nodeData.CmmVUuid,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => console.log('PROMISE DJ Error:', err));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS:
			return data.map(nodeData => {
				const _date = moment(nodeData.children[8].value).format('MMM-DD-YYYY');
				return {
					nodeId: nodeData.children[21].value,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS,
					data: nodeData,
					name: `${nodeData.children[9].value}-${nodeData.children[5].value}(${nodeData.children[10].value})`,
					count: nodeData.children[10].value,
					vendor: nodeData.children[23].value,
					status: nodeData.children[6].value,
					totalPendingAmt: nodeData.children[0].value,
					contractAmt: nodeData.children[1].value,
					currentAmt: nodeData.children[2].value,
					contractCode: nodeData.children[5].value,
					date: _date,
					postedAmount: nodeData.children[13].value,
					pendingAmount: nodeData.children[15].value,
					toBePaid: nodeData.children[18].value,
					completed: nodeData.children[22].value,
				};
			});

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS:
			return data.map(nodeData => {
				const _date = moment(nodeData.children[23].value).format('MMM-DD-YYYY');
				return {
					nodeId: nodeData.children[6].value,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS,
					name: `${nodeData.children[24].value}: ${nodeData.children[21].value} (${nodeData.children[1].value})`,
					count: nodeData.children[1].value,
					vendor: nodeData.children[12].value,
					status: nodeData.children[27].value,
					date: _date,
					contChngCode: nodeData.children[2].value,
					contractAmt: nodeData.children[25].value,
					partnerCode: nodeData.children[6].value,
					contractCode: nodeData.children[2].value,
					jobCode: nodeData.children[15].value,
					data: nodeData,
				};
			});

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
			const roles = await fetchUserRole(userInfo?.PmpVUuid, 'PMDOCUMENT', userInfo);

			const reqData = [];
			let idx = 0;
			data.items.forEach(nodeData => {
				// Key to check if we want to add document folder in the list or not
				const showInMenuKey = USER_ROLE_TYPE.SHOW + nodeData?.PmdgtTypeCode;
				const viewDocKey = USER_ROLE_TYPE.VIEW + nodeData?.PmdgtTypeCode;

				if (nodeData?.PmdgtTypeCode !== 'DRAWMGMT' && roles[showInMenuKey] && roles[viewDocKey]) {
					reqData.push({
						...nodeData,
						id: `${nodeData?.PmdgtSeqNum}-${idx}`,
						name: nodeData.PmdgtTypeName,
						nodeId: nodeData.PmdgtSeqNum,
						ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE,
						count: nodeData?.PmdgTotalDocs || 0,
						Icon: ICON_NAMES.FOLDER,
						isDocUploadable: roles[USER_ROLE_TYPE.CREATE + nodeData?.PmdgtTypeCode], // Checks if we want to disable upload documents or not
						index: idx,
					});
					idx++;
				}
			});

			return {
				items: reqData,
				hasMore: data.hasMore,
				totalResults: data.totalResults,
			};

		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
			await data.items.map(async (nodeData, index) => {
				items.push(
					new Promise(async (resolve, reject) => {
						//const result = await fetchDocRevisions(nodeData.VUuid, CMIC_FIELD_REST__NAMES.doc_for_documenttypes, userInfo);

						const revDate = moment(nodeData.PmdRevDate).format('MMM-DD-YYYY');
						const receivedDate = moment(nodeData.PmdPmdrLatestCreateDate).format('MMM-DD-YYYY');
						// IMPLEMENTATION - ISSUE count is missing => nodeData?.children[3]?.value
						resolve({
							...nodeData,
							nodeId: nodeData.PmdOraseq,
							name: nodeData?.PmdTitle || '-',
							id: `${nodeData?.PmdOraseq}-${index}`,
							//count: result.count-1,
							ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION || '-',
							Icon: ICON_NAMES.FILE,
							index,
							VUuid: nodeData.VUuid,
							PmdRevDate: revDate,
							'Date Received': receivedDate,
							//uploadedBy: result.items[0].PmdrContactName,
							//Version: result.items[0].PmdrComment,
							//revAttPath: result.items[0].PmdrAttPath,
						});
					}),
				);
			});

			return Promise.all(items)
				.then(resp => {
					return {
						items: resp,
						hasMore: data.hasMore,
						totalResults: data.totalResults,
					};
				})
				.catch(err => console.log('PROMISE DJ Error:', err));

		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION:
			items = data.items.map((nodeData, index) => {
				const revDate = moment(nodeData.PmdrRevDate).format('MMM-DD-YYYY');
				return {
					...nodeData,
					nodeId: nodeData.PmdrRevOraseq,
					name: nodeData?.PmdrAttPath || '-',
					id: `${nodeData?.PmdrRevOraseq}-${index}`,
					count: nodeData?.PmdrRevNum,
					PmdrRevNum: nodeData?.PmdrRevNum.toString(),
					ecmParentNodeType: null,
					Icon: ICON_NAMES.FILE,
					index,
					PmdrRevDate: revDate,
				};
			});
			return {
				items,
				hasMore: data.hasMore,
				totalResults: data.totalResults,
			};

		case CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			items = (data.items || []).map((nodeData, index) => {
				const _date = moment(nodeData.SysrdDate).format('MMM-DD-YYYY');
				return {
					nodeId: nodeData?.SysrdDocOraseq,
					id: nodeData?.SysrdDocId + index.toString(),
					SysrdDate: _date,
					index,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT,
					Icon: ICON_NAMES.FILE,
					// Icon: nodeData.DocumentsView.length > 0 ? ICON_NAMES.FILE_REVERSE : ICON_NAMES.FILE,
					...nodeData,
				};
			});

			return {
				items,
				hasMore: data.hasMore,
				totalResults: data.totalResults,
			};

		case CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
			return data.map(nodeData => {
				const _date = moment(nodeData.children[28].value).format('MMM-DD-YYYY');

				return {
					nodeId: nodeData.children[9].value,
					name: nodeData.children[5].value,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT,
					folder: nodeData.children[6].value,
					createdOn: _date,
					createdBy: nodeData.children[15].value,
					size: nodeData.children[16].value,
					children: [],
					data: nodeData,
				};
			});

		default:
			return null;
	}
};
